module.exports = (__webpack_public_path__ || '') + "static/images/android-chrome-192x192-4d590a184661faa26df91aa4301c3e7e.png";